import React from "react";
import {
  f7,
  Page,
  Card,
  CardContent,
  CardHeader,
  Icon,
  Preloader,
  List,
  ListItem,
  Navbar,
  NavTitle,
  Button,
  Block,
  BlockTitle,
  Link,
  Popup,
  NavRight,
  Swiper,
  SwiperSlide,
  Badge,
} from "framework7-react";

import {
  formateTimestamp,
  formateTimestampTime,
  renderDate,
  renderDateISO8601,
} from "../../../functions";

import { API_URL } from "../../../api";
import PageBlock from "../../shared/pageBlock/pageBlock";
import Checkout from "./checkout/checkout";
import Separator from "../../shared/separator/separator";

import LanguageSelector from "../../shared/i18nLanguageSelector/languageSelector";
import { withTranslation } from "react-i18next";

import { atcb_action } from "add-to-calendar-button";
import "add-to-calendar-button/assets/css/atcb.css";

import "./ticketPage.css";

var stylesheet;

class TicketPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errMgs: null,
      tID: this.props.f7route.params.id,
      data: null,
      remove_user_arr: [],
    };
  }

  componentDidMount() {
    this.loadXhr();
    if (!stylesheet) {
      stylesheet = document.createElement("style");
      document.head.appendChild(stylesheet);
    }
    document.title = "Påmeldinger.no";
  }

  loadXhr() {
    const { t } = this.props;
    const tid = this.props.f7route.params.id;
    this.setState({
      loading: true,
    });
    fetch(API_URL + "/ticket/get", {
      method: "POST",
      body: JSON.stringify({
        tid: tid,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.err_code === 0) {
          //check if tid is correct:
          if (data.tid && data.tid !== tid) {
            let redirect_url = `https://pameldinger.no/t/${data.tid}`;
            window.location.replace(redirect_url);
          }

          this.setState({
            loading: false,
            error: false,
            data: data,
          });
          //set document title
          document.title = `${data.event_data.title}`;
          //set color teme
          this.setColorTheme(data.event_options.theme_color);

          this.save_ticket_preview();

          if (
            data.event_options.allow_cancel === 1 &&
            data.group &&
            data.group.group_parent &&
            data.group.group.length > 0
          ) {
            let remove_user_arr = [this.state.tID.slice(6)];
            let n;
            for (n of data.group.group) {
              remove_user_arr.push(n.t_id);
            }
            this.setState({ remove_user_arr: remove_user_arr });
          }
        } else if (data.err_code === 4) {
          this.loadXhr();
        } else if (data.err_code === 19) {
          this.setState({
            loading: false,
            error: true,
            server_error: true,
            error_mgs: t("warnings.unknown_error"),
          });
        } else {
          document.title = t("not_valid");
          this.setState({
            loading: false,
            error: true,
            deleted: data.deleted,
            error_mgs: data.err_mgs,
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
          server_error: true,
          error_mgs: t("warnings.unknown_error"),
        });
      });
  }

  save_ticket_exist(v, id) {
    for (var i = 0; i < v.length; ++i) {
      if (v[i].tid == id) {
        return false;
      }
    }
    return true;
  }

  save_ticket_preview = () => {
    const tid = this.props.f7route.params.id;
    const registrations = localStorage.getItem("registrations");
    let new_arr = [];
    if (registrations) {
      new_arr = JSON.parse(registrations);
    }
    if (this.save_ticket_exist(new_arr, tid)) {
      new_arr.push({ eid: tid.substring(0, 6), tid: tid, created: Date.now() });
      localStorage.setItem("registrations", JSON.stringify(new_arr));
    }
  };

  generateStylesheet(hex) {
    var self = this;
    var styles = "";
    if (hex) {
      const colorThemeProperties = f7.utils.colorThemeCSSProperties(hex);
      if (Object.keys(colorThemeProperties).length) {
        styles += `
          body {
          ${Object.keys(colorThemeProperties)
            .map((key) => `${key}: ${colorThemeProperties[key]} !important;`)
            .join("\n  ")}
          --f7-bars-bg-color: ${hex};
          --f7-navbar-bg-color:  ${hex};
          }`;
      }
    }
    return styles.trim();
  }

  setColorTheme(hex) {
    var self = this;
    if (hex && stylesheet) {
      stylesheet.innerHTML = self.generateStylesheet(hex);
    }
  }

  renderQrText(tID) {
    return tID
      .match(/.{1,2}/g)
      .join("-")
      .toUpperCase();
  }

  renderCalcVat = (p) => {
    const { t } = this.props;
    if (this.state.data.event_options.add_vat > 0) {
      let vat = Math.round(
        (p / 100) *
          (this.state.data.event_options.add_vat /
            (this.state.data.event_options.add_vat + 1))
      );
      if (vat > 0) {
        return (
          <>
            <br />
            <span style={{ fontSize: "13px", color: "#666" }}>
              ({t("checkout.vat_display", { vat: vat })})
            </span>
          </>
        );
      }
    }
    return false;
  };

  redner_total_group_price = () => {
    let sum = this.state.data.col.price;
    this.state.data.group.group.forEach((n) => {
      sum =
        sum +
        this.state.data.group.group_col.find((x) => x.id === n.type).price;
    });
    return sum;
  };

  format_html = (html) => {
    return html.replace(/<a href/g, '<a class="external" target="_blank" href');
  };

  render_payment_option = () => {
    const { t } = this.props;
    return (
      <>
        <Card className="card-background-light" style={{ marginTop: "20px" }}>
          <CardContent>
            <p>
              {t("checkout.complete_order_by_info", {
                time: formateTimestampTime(this.state.data.reserved_to),
              })}
            </p>
          </CardContent>
        </Card>
        <BlockTitle style={{ marginTop: "24px" }}>
          {t("checkout.order")}
        </BlockTitle>
        {this.state.data.group ? (
          <Card>
            <CardContent style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}>
              {this.state.data.group.group_parent && (
                <List>
                  <ListItem
                    title={
                      this.state.data.name
                        ? `${this.state.data.name}`
                        : `${t("participant")} 1`
                    }
                    after={`${this.state.data.col.price / 100} kr`}
                  ></ListItem>
                  {this.state.data.group.group.map((n, i) => (
                    <ListItem
                      title={
                        n.name ? `${n.name}` : `${t("participant")} ${i + 2}`
                      }
                      after={`${
                        this.state.data.group.group_col.find(
                          (x) => x.id === n.type
                        ).price / 100
                      } kr`}
                    ></ListItem>
                  ))}
                </List>
              )}
            </CardContent>
            <CardContent
              style={{
                height: "5px",
                padding: 0,
                backgroundColor: "var(--f7-theme-color)",
              }}
            ></CardContent>
            <CardContent>
              <List>
                <ListItem
                  title={
                    <>
                      <b>{t("checkout.total_amount")}</b>
                      {this.renderCalcVat(this.redner_total_group_price())}
                    </>
                  }
                >
                  <b>{this.redner_total_group_price() / 100} kr</b>
                </ListItem>
              </List>
            </CardContent>
          </Card>
        ) : (
          <Card>
            <CardContent>
              <p style={{ fontSize: "18px", lineHeight: "16px" }}>
                {this.state.data.col.title
                  ? this.state.data.col.title
                  : this.state.data.event_data.title}
              </p>
            </CardContent>
            <CardContent
              style={{
                height: "5px",
                padding: 0,
                backgroundColor: "var(--f7-theme-color)",
              }}
            ></CardContent>
            <CardContent>
              <List>
                <ListItem
                  title={
                    <>
                      <b>{t("checkout.total_amount")}</b>
                      {this.renderCalcVat(this.state.data.col.price)}
                    </>
                  }
                >
                  <b>{this.state.data.col.price / 100} kr</b>
                </ListItem>
              </List>
            </CardContent>
          </Card>
        )}
        <Checkout
          sid={this.props.f7route.params.id}
          group={this.state.data.group}
          price={
            this.state.data.group
              ? this.redner_total_group_price() / 100
              : this.state.data.col.price / 100
          }
          theme={this.state.data.event_options.theme}
          vipps={this.state.data.vipps_payment}
          stripe_key={this.state.data.stripe_org}
          reload={this.loadXhr.bind(this)}
        />
      </>
    );
  };

  render() {
    const { t } = this.props;
    return this.state.loading ? (
      <Page>
        <div className="text-align-center" style={{ margin: "26px" }}>
          <Preloader></Preloader>
        </div>
      </Page>
    ) : this.state.error ? (
      this.state.server_error ? (
        <Page>
          <PageBlock width="520px">
            <BlockTitle className="text-align-center">
              Vi har problemer.
            </BlockTitle>
            <Block className="text-align-center">
              <p>
                Vi har for øyeblikket problemer med å koble til våre servere, så
                vi kan ikke vise din påmelding. Vi jobber nå med å løse
                problemet.
              </p>

              <p>Prøv å last inn siden på nytt igjen om 1 – 2 minutter.</p>
            </Block>
            <div
              style={{
                width: "100%",
                maxWidth: "240px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                onClick={() => {
                  this.loadXhr();
                }}
                large
                outline
              >
                Last inn på nytt
              </Button>
            </div>
            <br />
            <Block className="text-align-center">
              <p>
                <b>
                  Har du fremdeles problemer?
                  <br />
                  Ta kontakt til <b>kontakt@pameldinger.no</b>, så hjelper vi
                  deg.
                </b>
              </p>
            </Block>
          </PageBlock>
        </Page>
      ) : (
        <Page>
          <PageBlock width="520px">
            <Card outline>
              <CardContent
                style={{
                  backgroundColor: "#dfe4ea",
                  borderTopLeftRadius: "3px",
                  borderTopRightRadius: "3px",
                }}
              >
                <Icon
                  material="error"
                  style={{ marginRight: "12px", marginTop: "-5px" }}
                />
                <span style={{ fontSize: "18px" }}>{this.state.error_mgs}</span>
              </CardContent>
              <CardContent>
                <p>
                  Det kan være flere årsaker til at denne påmeldingen ikke er
                  gyldig. En årsak kan være at du har meldt deg av dette
                  arrangementet. Det kan også være at arrangøren har fjernet deg
                  fra arrangementet.
                </p>
                {this.state.deleted ? (
                  <p>
                    Arrangøren har slettet alle personopplysninger om deltakerne
                    på dette arrangementet. Følgelig er det ikke lenger mulig å
                    se om denne påmeldingen er gyldig.
                  </p>
                ) : (
                  <p>
                    Dersom du ikke forstår hvorfor påmelding ikke er gyldig, kan
                    du ta kontakt med arrangøren.
                  </p>
                )}
              </CardContent>
            </Card>
          </PageBlock>
        </Page>
      )
    ) : (
      <Page
        className={
          this.state.data.event_options.theme === 2 ? "theme-dark" : ""
        }
      >
        <Navbar>
          <NavTitle>
            {this.state.data.reserved
              ? t("sign_up.complete_order")
              : this.state.data.event_data.title}
          </NavTitle>
          <NavRight>
            <LanguageSelector />
          </NavRight>
        </Navbar>
        <PageBlock width="420px">
          {this.state.data.reserved
            ? this.render_payment_option()
            : this.renderTicketCard()}
        </PageBlock>
      </Page>
    );
  }

  cancelTicket() {
    const { t } = this.props;
    f7.dialog
      .create({
        title: t("are_you_sure"),
        text: t("ticket.are_you_sure_cancel_registration"),
        buttons: [
          {
            text: t("cancel"),
          },
          {
            text: t("ticket.cancel_registration"),
            color: "red",
            bold: true,
            onClick: () => this.xhrCancelTicket(),
          },
        ],
      })
      .open();
  }

  xhrCancelTicket() {
    const self = this;
    const { t } = this.props;

    f7.dialog.close();
    f7.dialog.preloader("Vent litt...");

    const tid = this.props.f7route.params.id;

    fetch(API_URL + "/ticket/cancel", {
      method: "POST",
      body: JSON.stringify({
        tid: tid,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        f7.dialog.close();
        if (data.err_code === 0) {
          self.loadXhr();
        } else {
          f7.dialog.alert(
            t("warnings.unknown_error"),
            t("warnings.unknown_error")
          );
        }
      })
      .catch((err) => {
        f7.dialog.close();
        f7.dialog.alert(
          t("warnings.unknown_error"),
          t("warnings.unknown_error")
        );
      });
  }

  renderTicketCard() {
    const { t } = this.props;
    const tid = this.props.f7route.params.id;
    return (
      <>
        <br />
        {this.state.data.waiting ? (
          <Card>
            {this.state.data.group ? (
              <>
                {this.state.data.event_options.hide_waiting_list_nr !== 1 && (
                  <CardHeader>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("ticket.you_are_on_the_waiting_list", {
                          event: this.state.data.event_data.title,
                        }),
                      }}
                    />
                  </CardHeader>
                )}
                <CardContent>
                  <p>{t("ticket.you_can_follow_your_place_in_the_queue")}</p>
                  <p>
                    <b>
                      <a
                        className="external"
                        href={`https://pameldinger.no/t/${tid}`}
                      >
                        https://pameldinger.no/t/{tid}
                      </a>
                    </b>
                  </p>
                  <p>{t("ticket.we_will_notify_you_if_you_get_ticket")}</p>
                </CardContent>
                <CardContent
                  style={{
                    height: "3px",
                    padding: 0,
                    backgroundColor: "var(--f7-theme-color)",
                  }}
                ></CardContent>
                <CardContent>
                  {this.state.data.group.group_parent ? (
                    <>
                      <p>{t("ticket.participants_in_group")}</p>
                      <List
                        mediaList
                        style={{
                          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                          marginTop: "12px",
                        }}
                      >
                        <ListItem
                          title={
                            this.state.data.name ? (
                              <>
                                {this.state.data.name}{" "}
                                <Badge textColor="black" color="yellow">
                                  Venteliste nr. {this.state.data.que}
                                </Badge>
                              </>
                            ) : (
                              "Deltaker 1"
                            )
                          }
                        ></ListItem>
                        {this.state.data.group.group.map((n, i) => (
                          <ListItem
                            title={
                              n.name ? (
                                <>
                                  {n.name}{" "}
                                  <Badge textColor="black" color="yellow">
                                    Venteliste nr. {n.que.que_nr}
                                  </Badge>
                                </>
                              ) : (
                                `Deltaker ${i + 2}`
                              )
                            }
                          ></ListItem>
                        ))}
                      </List>
                    </>
                  ) : (
                    <p>{t("ticket.part_of_group_ticket")}</p>
                  )}
                </CardContent>
              </>
            ) : (
              <>
                {this.state.data.event_options.hide_waiting_list_nr !== 1 && (
                  <CardHeader>
                    {t("ticket.your_place_in_the_que", {
                      nr: this.state.data.que,
                    })}
                  </CardHeader>
                )}
                <CardContent>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t("ticket.you_are_on_the_waiting_list", {
                        event: this.state.data.event_data.title,
                      }),
                    }}
                  />
                  <p>{t("ticket.you_can_follow_your_place_in_the_queue")}</p>
                  <p>
                    <b>
                      <a
                        className="external"
                        href={`https://pameldinger.no/t/${tid}`}
                      >
                        https://pameldinger.no/t/{tid}
                      </a>
                    </b>
                  </p>
                  <p>{t("ticket.we_will_notify_you_if_you_get_ticket")}</p>
                </CardContent>
                {this.state.data.event_col &&
                  this.state.data.event_col.title !== "" && (
                    <>
                      <CardContent
                        style={{
                          height: "3px",
                          padding: 0,
                          backgroundColor: "var(--f7-theme-color)",
                        }}
                      ></CardContent>
                      <CardContent
                        className={
                          this.state.data.event_col.special &&
                          "special_col_card"
                        }
                      >
                        <p>{t("type")}:</p>
                        <List mediaList>
                          <ListItem
                            title={
                              this.state.data.event_col.title !== "" &&
                              this.state.data.event_col.title
                            }
                            text={
                              this.state.data.event_col.desc !== "" &&
                              this.state.data.event_col.desc
                            }
                          ></ListItem>
                        </List>
                      </CardContent>
                    </>
                  )}
              </>
            )}
            {this.renderTicketCancel()}
          </Card>
        ) : (
          <>
            <Card>
              {this.state.data.group ? (
                <>
                  <CardContent>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("ticket.you_have_signed_up_plural", {
                          event: this.state.data.event_data.title,
                        }),
                      }}
                    />
                    {this.state.data.event_options.include_ticket === 1 && (
                      <>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: t("ticket.you_find_your_ticket_info", {
                              event: this.state.data.event_data.title,
                            }),
                          }}
                        />
                        <p>
                          <b>
                            <a
                              className="external"
                              href={`https://pameldinger.no/t/${tid}`}
                            >
                              https://pameldinger.no/t/{tid}
                            </a>
                          </b>
                        </p>
                        {this.state.data.event_options.ticket_on_email > 0 && (
                          <p>{t("ticket.this_ticket_is_sent_to_your_email")}</p>
                        )}
                      </>
                    )}
                  </CardContent>
                  <CardContent
                    style={{
                      height: "3px",
                      padding: 0,
                      backgroundColor: "var(--f7-theme-color)",
                    }}
                  ></CardContent>
                  {this.state.data.group.group_que && (
                    <>
                      <CardContent style={{ backgroundColor: "#FAD201" }}>
                        <p>
                          Noen av deltakerne i denne gruppen står på venteliste,
                          og har ikke plass på arrangementet.
                        </p>
                        <p>
                          Vi varsler deg automatisk på e-post dersom disse får
                          plass på arrangementet.
                        </p>
                      </CardContent>
                      <CardContent
                        style={{
                          height: "3px",
                          padding: 0,
                          backgroundColor: "var(--f7-theme-color)",
                        }}
                      ></CardContent>
                    </>
                  )}
                  {this.state.data.event_col ? (
                    <CardContent>
                      {this.state.data.group.group_parent ? (
                        <>
                          <p>{t("ticket.participants_in_group")}</p>
                          <List
                            mediaList
                            style={{
                              borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                              marginTop: "12px",
                            }}
                          >
                            <ListItem
                              className={
                                this.state.data.event_col.special &&
                                "special_col_card"
                              }
                              title={
                                <>
                                  {this.state.data.name
                                    ? `${this.state.data.name}`
                                    : `${t("participant")} 1`}
                                </>
                              }
                              subtitle={
                                this.state.data.event_col.title &&
                                `${t("type")}: ${
                                  this.state.data.event_col.title
                                }`
                              }
                            ></ListItem>
                            {this.state.data.group.group.map((n, i) => (
                              <ListItem
                                className={
                                  this.state.data.group.group_col.find(
                                    (x) => x.id === n.type
                                  ).special && "special_col_card"
                                }
                                title={
                                  <>
                                    {n.name
                                      ? `${n.name}`
                                      : `${t("participant")} ${i + 2}`}{" "}
                                    {n.que && (
                                      <Badge textColor="black" color="yellow">
                                        Venteliste nr. {n.que.que_nr}
                                      </Badge>
                                    )}
                                  </>
                                }
                                subtitle={
                                  this.state.data.group.group_col.find(
                                    (x) => x.id === n.type
                                  ).title &&
                                  `${t("type")}: ${
                                    this.state.data.group.group_col.find(
                                      (x) => x.id === n.type
                                    ).title
                                  }`
                                }
                              ></ListItem>
                            ))}
                          </List>
                        </>
                      ) : (
                        <p>{t("ticket.part_of_group_ticket")}</p>
                      )}
                    </CardContent>
                  ) : (
                    <CardContent>
                      {this.state.data.group.group_parent ? (
                        <>
                          <p>{t("ticket.participants_in_group")}</p>
                          <List
                            style={{
                              borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                              marginTop: "12px",
                            }}
                          >
                            <ListItem
                              title={
                                this.state.data.name
                                  ? `${this.state.data.name}`
                                  : "Deltaker 1"
                              }
                            ></ListItem>
                            {this.state.data.group.group.map((n, i) => (
                              <ListItem
                                title={
                                  <>
                                    {n.name ? `${n.name}` : `Deltaker ${i + 2}`}{" "}
                                    {n.que && (
                                      <Badge textColor="black" color="yellow">
                                        Venteliste nr. {n.que.que_nr}
                                      </Badge>
                                    )}
                                  </>
                                }
                              ></ListItem>
                            ))}
                          </List>
                        </>
                      ) : (
                        <p>{t("ticket.part_of_group_ticket")}</p>
                      )}
                    </CardContent>
                  )}
                </>
              ) : (
                <>
                  <CardContent>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("ticket.you_have_signed_up", {
                          event: this.state.data.event_data.title,
                        }),
                      }}
                    />
                    {this.state.data.event_options.include_ticket === 1 && (
                      <>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: t("ticket.you_find_your_ticket_info", {
                              event: this.state.data.event_data.title,
                            }),
                          }}
                        />
                        <p>
                          <b>
                            <a
                              className="external"
                              href={`https://pameldinger.no/t/${tid}`}
                            >
                              https://pameldinger.no/t/{tid}
                            </a>
                          </b>
                        </p>
                        {this.state.data.event_options.ticket_on_email > 0 && (
                          <p>{t("ticket.this_ticket_is_sent_to_your_email")}</p>
                        )}
                      </>
                    )}
                  </CardContent>
                  {this.state.data.event_col &&
                    this.state.data.event_col.title !== "" && (
                      <>
                        <CardContent
                          style={{
                            height: "3px",
                            padding: 0,
                            backgroundColor: "var(--f7-theme-color)",
                          }}
                        ></CardContent>
                        <CardContent
                          className={
                            this.state.data.event_col.special &&
                            "special_col_card"
                          }
                        >
                          <p>{t("type")}:</p>
                          <List mediaList>
                            <ListItem
                              title={
                                this.state.data.event_col.title !== "" &&
                                this.state.data.event_col.title
                              }
                              text={
                                this.state.data.event_col.desc !== "" &&
                                this.state.data.event_col.desc
                              }
                            ></ListItem>
                          </List>
                        </CardContent>
                      </>
                    )}
                </>
              )}
              {this.renderTicketCancel()}
            </Card>

            {this.state.data.event_options.ticket_on_email_body &&
              this.state.data.event_options.ticket_on_email_body.length >
                100 && (
                <>
                  <BlockTitle>{t("information_from_the_organizer")}</BlockTitle>
                  <Card>
                    <CardContent>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.format_html(
                            this.state.data.event_options.ticket_on_email_body
                          ),
                        }}
                      />
                    </CardContent>
                  </Card>
                  <Block style={{ marginTop: 0, opacity: 0.8 }}>
                    <i>{t("this_information_is_sent_to_your_email")}</i>
                  </Block>
                </>
              )}

            {this.state.data.event_options.include_ticket === 1 && (
              <>
                <BlockTitle>{t("ticket.your_ticket")}</BlockTitle>
                <Card>
                  <CardContent>
                    <p>{t("ticket.here_is_your_ticket_info")}</p>
                  </CardContent>
                  <div className={"hideMobileScreen"}>
                    <CardContent
                      style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
                    >
                      <Button
                        raised
                        fill
                        large
                        external
                        target="_blank"
                        href={`https://pameldinger.no/ticket/download?tid=${tid}`}
                      >
                        <Icon
                          style={{ marginRight: "8px" }}
                          material="print"
                        ></Icon>
                        {t("ticket.download_ticket")}
                      </Button>
                    </CardContent>
                  </div>
                  <div className={"hideFullScreen"}>
                    <CardContent
                      style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
                    >
                      <Button fill large popupOpen=".register-popup">
                        <Icon style={{ marginRight: "8px" }} f7="qrcode"></Icon>
                        {t("ticket.check_ticket")}
                      </Button>
                    </CardContent>
                    <Separator text={t("or")} />
                    <CardContent>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t("ticket.download_ticket_info"),
                        }}
                      />
                      <Button
                        fill
                        raised
                        large
                        external
                        target="_blank"
                        href={`https://pameldinger.no/ticket/download?tid=${tid}`}
                      >
                        <Icon
                          style={{ marginRight: "8px" }}
                          material="print"
                        ></Icon>
                        {t("ticket.download_ticket")}
                      </Button>
                    </CardContent>
                  </div>
                </Card>
              </>
            )}
          </>
        )}

        <BlockTitle>{t("info")}</BlockTitle>
        <Card>
          <CardContent>
            <List>
              <ListItem title={`${t("event.organizer")}:`}>
                <span style={{ fontSize: "15px" }}>
                  {this.state.data.event_data.organizer}
                </span>
              </ListItem>
            </List>
          </CardContent>
          <CardContent
            style={{
              height: "3px",
              padding: 0,
              backgroundColor: "var(--f7-theme-color)",
            }}
          ></CardContent>
          <CardContent>
            <List>
              <ListItem title={`${t("event.start")}:`}>
                <span style={{ fontSize: "15px" }}>
                  {formateTimestamp(this.state.data.event_data.periode.start)}
                </span>
              </ListItem>
              {this.state.data.event_data.periode.end > 0 && (
                <ListItem title={`${t("event.end")}:`}>
                  <span style={{ fontSize: "15px" }}>
                    {formateTimestamp(this.state.data.event_data.periode.end)}
                  </span>
                </ListItem>
              )}
              {this.state.data.event_data.adr && (
                <ListItem title={`${t("event.where")}:`}>
                  <span style={{ fontSize: "15px" }}>
                    {this.state.data.event_data.adr}
                    {this.state.data.event_data.adr_full &&
                      `, ${this.state.data.event_data.adr_full.secondary}`}
                    {this.state.data.event_data.adr_full &&
                      this.state.data.event_data.adr_full.desc && (
                        <>
                          <br />
                          {this.state.data.event_data.adr_full.desc}
                        </>
                      )}
                  </span>
                </ListItem>
              )}
            </List>
          </CardContent>
          <CardContent style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}>
            <Button
              fill
              raised
              large
              onClick={() => {
                const config = {
                  name: this.state.data.event_data.title,
                  description: `Her er din billett:<br>→ [url]https://pameldinger.no/t/${tid}[/url]`,
                  startDate: renderDateISO8601(
                    this.state.data.event_data.periode.start
                  ),
                  endDate: renderDateISO8601(
                    this.state.data.event_data.periode.end
                  ),
                  startTime: formateTimestampTime(
                    this.state.data.event_data.periode.start
                  ),
                  endTime: formateTimestampTime(
                    this.state.data.event_data.periode.end
                  ),
                  options: [
                    "Google",
                    "iCal",
                    "Apple",
                    "Microsoft365",
                    "MicrosoftTeams",
                    "Outlook.com",
                  ],
                  timeZone: "Europe/Oslo",
                  location: this.state.data.event_data.adr_full
                    ? `${this.state.data.event_data.adr_full.main}, ${this.state.data.event_data.adr_full.secondary}`
                    : this.state.data.event_data.adr
                    ? this.state.data.event_data.adr
                    : false,
                  trigger: "click",
                  iCalFileName: this.state.data.event_data.title.replaceAll(
                    " ",
                    "-"
                  ),
                };
                atcb_action(config);
              }}
            >
              <Icon style={{ marginRight: "8px" }} material="event"></Icon>
              Legg til i kalender
            </Button>
          </CardContent>
        </Card>
        {this.state.data.event_data.adr_full && (
          <Block style={{ marginTop: "12px" }}>
            <a
              dangerouslySetInnerHTML={{
                __html: t("get_directions", {
                  adr: this.state.data.event_data.adr,
                }),
              }}
              style={{ textDecoration: "underline" }}
              className="external"
              target="_blank"
              href={`https://www.google.com/maps/search/?api=1&query=${this.state.data.event_data.adr}+${this.state.data.event_data.adr_full.secondary}&query_place_id=${this.state.data.event_data.adr_full.place_id}`}
            />
          </Block>
        )}

        {this.state.data.receipt && (
          <>
            <BlockTitle style={{ marginTop: "24px" }}>
              {t("checkout.payment")}
            </BlockTitle>
            <Card>
              <CardContent>
                <List>
                  <ListItem
                    title={
                      <>
                        {t("checkout.amount_charged")}
                        {this.state.data.receipt.vat > 0 && (
                          <>
                            <br />
                            <span style={{ fontSize: "13px", color: "#666" }}>
                              (
                              {t("checkout.vat_display", {
                                vat: this.state.data.receipt.vat / 100,
                              })}
                              )
                            </span>
                          </>
                        )}
                      </>
                    }
                  >
                    <span>{this.state.data.receipt.total / 100} kr</span>
                  </ListItem>
                </List>
              </CardContent>
              <CardContent
                style={{
                  height: "3px",
                  padding: 0,
                  backgroundColor: "var(--f7-theme-color)",
                }}
              ></CardContent>
              {this.state.data.receipt.payment_type === 1 && (
                <>
                  <CardContent>
                    <List>
                      <ListItem
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("checkout.date_paid")}
                          </span>
                        }
                      >
                        <span style={{ fontSize: "15px" }}>
                          {renderDate(this.state.data.receipt.paid_date)}
                        </span>
                      </ListItem>
                      <ListItem
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("checkout.payment_method")}
                          </span>
                        }
                      >
                        <span style={{ fontSize: "15px" }}>
                          {this.state.data.receipt.payment_data.brand.toUpperCase()}{" "}
                          {this.state.data.receipt.payment_data.last4}
                        </span>
                      </ListItem>
                      <ListItem
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("checkout.transaction_id")}
                          </span>
                        }
                      >
                        <span style={{ fontSize: "15px" }}>
                          {this.state.data.receipt.t_id.substring(0, 3)}-
                          {this.state.data.receipt.t_id.substring(3, 6)}
                        </span>
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardContent
                    style={{
                      height: "1px",
                      padding: 0,
                      backgroundColor: "var(--f7-theme-color)",
                    }}
                  ></CardContent>
                  {this.state.data.receipt.payment_data.receipt_url && (
                    <CardContent>
                      <List>
                        <ListItem
                          title={t("view_more")}
                          external
                          target="_blank"
                          link={
                            this.state.data.receipt.payment_data.receipt_url
                          }
                        />
                      </List>
                    </CardContent>
                  )}
                </>
              )}
              {this.state.data.receipt.payment_type === 2 && (
                <>
                  <CardContent>
                    <List>
                      <ListItem
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("checkout.date_paid")}
                          </span>
                        }
                      >
                        <span style={{ fontSize: "15px" }}>
                          {renderDate(this.state.data.receipt.paid_date)}
                        </span>
                      </ListItem>
                      <ListItem
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("checkout.payment_method")}
                          </span>
                        }
                      >
                        <span style={{ fontSize: "15px" }}>
                          Vipps (
                          <i>
                            {
                              this.state.data.receipt.payment_data
                                .transaction_id
                            }
                          </i>
                          )
                        </span>
                      </ListItem>
                      <ListItem
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("checkout.transaction_id")}
                          </span>
                        }
                      >
                        <span style={{ fontSize: "15px" }}>
                          {this.state.data.receipt.t_id.substring(0, 3)}-
                          {this.state.data.receipt.t_id.substring(3, 6)}
                        </span>
                      </ListItem>
                    </List>
                  </CardContent>
                </>
              )}
            </Card>
          </>
        )}
        <BlockTitle style={{ marginTop: "24px" }}>
          {t("legal_info.terms_and_privacy")}
        </BlockTitle>
        <Block>
          <p
            dangerouslySetInnerHTML={{
              __html: t("legal_info.your_privacy_is_important"),
            }}
          />
        </Block>

        <div style={{ height: "60px" }}></div>
        {this.ticket_control_qr()}
      </>
    );
  }
  renderTicketCancel() {
    const { t } = this.props;
    let current_time = Math.floor(Date.now() / 1000);
    if (
      this.state.data.event_data.event_type === 1 &&
      this.state.data.event_options.allow_cancel === 1 &&
      (this.state.data.event_options.cancel_time > current_time ||
        this.state.data.event_options.cancel_time === 0) &&
      (this.state.data.checked_in === 0 || this.state.data.waiting)
    ) {
      return (
        <>
          <CardContent
            style={{
              height: "3px",
              padding: 0,
              backgroundColor: "var(--f7-theme-color)",
            }}
          ></CardContent>
          <CardContent>
            <p>
              {t("event.available_for_cancelation")}{" "}
              {this.state.data.event_options.cancel_time > 0 &&
                t("event.cancelation_deadline", {
                  date_time: formateTimestamp(
                    this.state.data.event_options.cancel_time
                  ),
                })}
            </p>
            {this.state.data.group && this.state.data.group.group_parent ? (
              <>
                <Button
                  popupOpen=".remove_participant-popup"
                  color="red"
                  fill
                  large
                >
                  {t("ticket.cancel_your_registration_group")}
                </Button>
                {this.remove_participant_popup()}
              </>
            ) : (
              <Button
                onClick={() => this.cancelTicket()}
                color="red"
                fill
                large
              >
                {t("ticket.cancel_your_registration")}
              </Button>
            )}
          </CardContent>
        </>
      );
    }
    if (
      this.state.data.event_data.event_type === 1 &&
      this.state.data.event_options.allow_cancel === 1 &&
      (this.state.data.event_options.cancel_time <= current_time ||
        this.state.data.event_options.cancel_time === 0) &&
      (this.state.data.checked_in === 0 || this.state.data.waiting)
    ) {
      return (
        <>
          <CardContent
            style={{
              height: "3px",
              padding: 0,
              backgroundColor: "var(--f7-theme-color)",
            }}
          ></CardContent>
          <CardContent>
            <p>
              {t("event.not_available_for_cancelation")}{" "}
              {this.state.data.event_options.cancel_time > 0 &&
                t("event.cancelation_deadline_was", {
                  date_time: formateTimestamp(
                    this.state.data.event_options.cancel_time
                  ),
                })}
            </p>
          </CardContent>
        </>
      );
    }
  }

  renderIsCheckedIn(checked_in, checked_in_time) {
    const { t } = this.props;
    if (checked_in === 1) {
      return (
        <Card outline>
          <CardContent
            style={{
              backgroundColor: "#dfe4ea",
              borderTopLeftRadius: "3px",
              borderTopRightRadius: "3px",
            }}
          >
            <Icon
              material="error"
              style={{ marginRight: "12px", marginTop: "-5px" }}
            />
            <span style={{ fontSize: "18px" }}>
              {t("ticket.ticket_is_used")}
            </span>
          </CardContent>
          <CardContent>
            <p>
              {t("ticket.ticket_is_used", {
                time: this.getTimeLeft(checked_in_time),
              })}
              <br />({formateTimestamp(checked_in_time)})
            </p>
          </CardContent>
        </Card>
      );
    }
  }

  getTimeLeft(UNIX_timestamp) {
    UNIX_timestamp = parseInt(UNIX_timestamp);

    var timeNow = Math.floor(new Date().getTime() / 1000);
    var d = timeNow - UNIX_timestamp;
    var d_days = Math.floor(d / (24 * 60 * 60));
    var d_hours = Math.floor(d / (60 * 60));
    var d_minutes = Math.floor(d / 60);
    var d_second = Math.floor(d);
    if (d_days >= 2) {
      return d_days + " dager";
    } else if (d_days < 2 && d_days >= 1) {
      return d_days + " dag";
    } else if (d_days < 1 && d_hours >= 2) {
      return d_hours + " timer " + (d_minutes - 60 * d_hours) + " minutter";
    } else if (d_hours < 2 && d_hours >= 1) {
      return d_hours + " time";
    } else if (d_hours < 1 && d_minutes >= 2) {
      return d_minutes + " minutter";
    } else if (d_minutes < 2 && d_minutes >= 1) {
      return d_minutes + " minutt";
    } else if (d_minutes < 1 && d_second >= 0) {
      return " mindre enn 1 minutt";
    }
  }

  timeConverter(UNIX_timestamp) {
    var a = new Date(UNIX_timestamp * 1000);
    var year = "0" + a.getFullYear();
    var month = "0" + (a.getMonth() + 1);
    var date = "0" + a.getDate();
    var hour = "0" + a.getHours();
    var min = "0" + a.getMinutes();
    var time =
      date.substr(-2) +
      "." +
      month.substr(-2) +
      "." +
      year.substr(-2) +
      ", kl. " +
      hour.substr(-2) +
      "." +
      min.substr(-2);
    return time;
  }

  ticket_control_qr = () => {
    const { t } = this.props;
    return (
      <Popup
        className="register-popup"
        onPopupOpen={() => this.setState({ popup_ready: true })}
        closeByBackdropClick
      >
        <Page>
          <Navbar title={t("ticket.check_ticket")}>
            <NavRight>
              <Link popupClose iconMaterial="close" iconOnly />
            </NavRight>
          </Navbar>
          {this.state.data.group &&
          this.state.data.group.group_parent &&
          this.state.data.group.group.length > 0 ? (
            this.state.popup_ready && (
              <Swiper
                className="user_registration_swiper"
                pagination
                navigation
              >
                <SwiperSlide>
                  <BlockTitle
                    style={{
                      width: "222px",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }}
                  >
                    {this.state.data.name
                      ? `${this.state.data.name}`
                      : `${t("participant")} 1`}
                  </BlockTitle>
                  <Card
                    style={{
                      width: "222px",
                      marginRight: "auto",
                      marginLeft: "auto",
                      padding: 0,
                      marginBottom: "26px",
                      marginTop: "22px",
                    }}
                  >
                    <CardContent
                      style={{
                        display: "block",
                        textAlign: "center",
                        margin: "0px",
                      }}
                    >
                      <img
                        style={{ width: "190px", height: "190px" }}
                        src={`https://qr-code-generator-dot-onepark-landlord.ey.r.appspot.com/${this.state.tID}`}
                        alt=""
                      />
                      <p
                        style={{
                          fontSize: "20px",
                          fontWeight: 600,
                          lineHeight: "10px",
                          marginTop: "14px",
                        }}
                      >
                        {this.renderQrText(this.state.tID.slice(6))}
                      </p>
                    </CardContent>
                  </Card>
                  {this.renderIsCheckedIn(
                    this.state.data.checked_in,
                    this.state.data.checked_in_time
                  )}
                </SwiperSlide>
                {this.state.data.group.group.map((n, i) => (
                  <SwiperSlide>
                    <BlockTitle
                      style={{
                        width: "222px",
                        marginRight: "auto",
                        marginLeft: "auto",
                      }}
                    >
                      {n.name ? `${n.name}` : `${t("participant")} ${i + 2}`}
                    </BlockTitle>
                    <Card
                      style={{
                        width: "222px",
                        marginRight: "auto",
                        marginLeft: "auto",
                        padding: 0,
                        marginBottom: "26px",
                        marginTop: "22px",
                      }}
                    >
                      <CardContent
                        style={{
                          display: "block",
                          textAlign: "center",
                          margin: "0px",
                        }}
                      >
                        <img
                          style={{ width: "190px", height: "190px" }}
                          src={`https://qr-code-generator-dot-onepark-landlord.ey.r.appspot.com/${this.state.tID.substring(
                            0,
                            6
                          )}${n.t_id}`}
                          alt=""
                        />
                        <p
                          style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            lineHeight: "10px",
                            marginTop: "14px",
                          }}
                        >
                          {this.renderQrText(n.t_id)}
                        </p>
                      </CardContent>
                    </Card>
                    {this.renderIsCheckedIn(n.checked_in, n.checked_in_time)}
                  </SwiperSlide>
                ))}
              </Swiper>
            )
          ) : (
            <>
              <Card
                style={{
                  width: "222px",
                  marginRight: "auto",
                  marginLeft: "auto",
                  padding: 0,
                  marginBottom: "26px",
                  marginTop: "22px",
                }}
              >
                <CardContent
                  style={{
                    display: "block",
                    textAlign: "center",
                    margin: "0px",
                  }}
                >
                  <img
                    style={{ width: "190px", height: "190px" }}
                    src={`https://qr-code-generator-dot-onepark-landlord.ey.r.appspot.com/${this.state.tID}`}
                    alt=""
                  />
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      lineHeight: "10px",
                      marginTop: "14px",
                    }}
                  >
                    {this.renderQrText(this.state.tID.slice(6))}
                  </p>
                </CardContent>
              </Card>
              {this.renderIsCheckedIn(
                this.state.data.checked_in,
                this.state.data.checked_in_time
              )}
            </>
          )}
          <Card
            outline
            style={{ marginTop: "8px", backgroundColor: "#CFD8DC" }}
          >
            <CardContent>
              <p>{t("ticket.organizer_scan_qr_code_info")}</p>
            </CardContent>
          </Card>
        </Page>
      </Popup>
    );
  };
  remove_participant_popup = () => {
    const { t } = this.props;
    return (
      <Popup className="remove_participant-popup">
        <Page>
          <Navbar title={t("ticket.cancel_your_registration_group")}>
            <NavRight>
              <Link popupClose iconMaterial="close" iconOnly />
            </NavRight>
          </Navbar>
          {this.state.data.group &&
            this.state.data.group.group_parent &&
            this.state.data.group.group.length > 0 && (
              <>
                <Card outline style={{ backgroundColor: "#CFD8DC" }}>
                  <CardContent>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("ticket.choose_participants_to_cancel", {
                          event: this.state.data.event_data.title,
                        }),
                      }}
                    />
                  </CardContent>
                </Card>
                <List>
                  <ListItem
                    checked={
                      Array.isArray(this.state.remove_user_arr) &&
                      this.state.remove_user_arr.includes(
                        this.state.tID.slice(6)
                      )
                    }
                    checkbox
                    onChange={() => {
                      let index = this.state.remove_user_arr.indexOf(
                        this.state.tID.slice(6)
                      );
                      if (index >= 0) {
                        let arr = this.state.remove_user_arr;
                        arr.splice(index, 1);
                        this.setState({ remove_user_arr: arr });
                      } else {
                        let arr = this.state.remove_user_arr;
                        arr.push(this.state.tID.slice(6));
                        this.setState({ remove_user_arr: arr });
                      }
                    }}
                    title={
                      this.state.data.name
                        ? `${this.state.data.name}`
                        : `${t("participant")} 1`
                    }
                  ></ListItem>
                  {this.state.data.group.group.map((n, i) => (
                    <ListItem
                      checked={
                        Array.isArray(this.state.remove_user_arr) &&
                        this.state.remove_user_arr.includes(n.t_id)
                      }
                      onChange={() => {
                        let index = this.state.remove_user_arr.indexOf(n.t_id);
                        if (index >= 0) {
                          let arr = this.state.remove_user_arr;
                          arr.splice(index, 1);
                          this.setState({ remove_user_arr: arr });
                        } else {
                          let arr = this.state.remove_user_arr;
                          arr.push(n.t_id);
                          this.setState({ remove_user_arr: arr });
                        }
                      }}
                      checkbox
                      title={
                        n.name ? `${n.name}` : `${t("participant")} ${i + 2}`
                      }
                    ></ListItem>
                  ))}
                </List>
                <Block>
                  <Button
                    disabled={this.state.remove_user_arr.length < 1}
                    popupClose
                    onClick={() => this.cancelGroupTicket()}
                    color="red"
                    fill
                    large
                  >
                    {this.state.remove_user_arr.length === 1
                      ? t("ticket.remove_nr_participants_single", {
                          nr: this.state.remove_user_arr.length,
                        })
                      : t("ticket.remove_nr_participants", {
                          nr: this.state.remove_user_arr.length,
                        })}
                  </Button>
                </Block>
              </>
            )}
        </Page>
      </Popup>
    );
  };

  cancelGroupTicket = () => {
    const { t } = this.props;

    f7.dialog
      .create({
        title: t("are_you_sure"),
        text: t("ticket.are_you_sure_cancel_registration"),
        buttons: [
          {
            text: t("cancel"),
          },
          {
            text: t("ticket.cancel_registration"),
            color: "red",
            bold: true,
            onClick: () => this.xhrCancelGroupTicket(),
          },
        ],
      })
      .open();
  };

  xhrCancelGroupTicket = () => {
    const { t } = this.props;
    const self = this;
    f7.dialog.close();
    f7.dialog.preloader(t("please_wait"));

    let arr = this.state.remove_user_arr;

    fetch(API_URL + "/ticket/cancel/group", {
      method: "POST",
      body: JSON.stringify({
        eid: this.state.tID.slice(0, -6),
        tid: arr,
        parent: this.state.tID.slice(6),
        all: this.state.data.group.group.length + 1 > arr.length ? false : true,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        f7.dialog.close();
        if (data.err_code === 0) {
          self.loadXhr();
        } else {
          f7.dialog.alert(
            t("warnings.unknown_error"),
            t("warnings.unknown_error")
          );
        }
      })
      .catch((err) => {
        f7.dialog.close();
        f7.dialog.alert(
          t("warnings.unknown_error"),
          t("warnings.unknown_error")
        );
      });
  };
}

export default withTranslation()(TicketPage);
